"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NW_PLUS_CHECKOUT_DATA_QUERY = void 0;
var react_1 = __importStar(require("react"));
var client_1 = require("@apollo/client");
var button_1 = __importDefault(require("../button"));
var use_session_storage_1 = __importDefault(require("./utils/use-session-storage"));
var use_subscribe_button_error_1 = require("./utils/use-subscribe-button-error");
var SUBSCRIPTION_REDIRECT_PATH_KEY = "subscription_redirect_path";
var NERDWALLET_PLUS_CHECKOUT_PATH = "/home/nerdwallet-plus/checkout";
exports.NW_PLUS_CHECKOUT_DATA_QUERY = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetNwPlusCheckoutData {\n    identity {\n      id\n      isNerdWalletPlusMember\n    }\n  }\n"], ["\n  query GetNwPlusCheckoutData {\n    identity {\n      id\n      isNerdWalletPlusMember\n    }\n  }\n"])));
var SubscribeButton = function (_a) {
    var _b;
    var _c = _a.block, block = _c === void 0 ? false : _c, children = _a.children, disabled = _a.disabled, onClick = _a.onClick, redirectPath = _a.redirectPath, _d = _a.secondary, secondary = _d === void 0 ? false : _d;
    var _e = (0, client_1.useQuery)(exports.NW_PLUS_CHECKOUT_DATA_QUERY), data = _e.data, loading = _e.loading;
    var _f = (_b = data === null || data === void 0 ? void 0 : data.identity) !== null && _b !== void 0 ? _b : {}, identityId = _f.id, isNerdWalletPlusMember = _f.isNerdWalletPlusMember;
    var redirectUrl = (0, react_1.useMemo)(function () {
        if (isNerdWalletPlusMember) {
            return redirectPath;
        }
        return NERDWALLET_PLUS_CHECKOUT_PATH;
    }, [isNerdWalletPlusMember, redirectPath]);
    var setItem = (0, use_session_storage_1.default)(identityId).setItem;
    var _g = (0, use_subscribe_button_error_1.useSubscribeButtonError)(), loadingSubscribeButtonError = _g.loading, hasError = _g.hasError;
    var handleClick = function () {
        onClick === null || onClick === void 0 ? void 0 : onClick();
        setItem(SUBSCRIPTION_REDIRECT_PATH_KEY, redirectPath);
        window.location.assign(redirectUrl);
    };
    return (react_1.default.createElement(button_1.default, { block: block, loading: loading || loadingSubscribeButtonError, disabled: disabled || loading || loadingSubscribeButtonError || hasError, onClick: handleClick, secondary: secondary }, children));
};
exports.default = SubscribeButton;
var templateObject_1;
